import * as type from './customAudioPlaylistActionTypes';

export const getCustomPlaylists = () => ({
  type: type.GET_CUSTOM_PLAYLISTS,
});

export const setCustomPlaylists = (playlists) => ({
  type: type.SET_CUSTOM_PLAYLISTS,
  playlists,
});

export const setCustomPlaylistsLoading = (loading) => ({
  type: type.SET_CUSTOM_PLAYLISTS_LOADING,
  loading,
});

export const setCustomPlaylistsError = (error) => ({
  type: type.SET_CUSTOM_PLAYLISTS_ERROR,
  error,
});

export const deleteCustomPlaylist = (playlistId) => ({
  type: type.DELETE_CUSTOM_PLAYLIST,
  playlistId,
});

export const removeCustomPlaylist = (playlistId) => ({
  type: type.REMOVE_CUSTOM_PLAYLIST,
  playlistId,
});
